import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./DatePicker.scss"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import { getLang } from "../../helper/global";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";


const BasicDatePicker = ({
  type = 1,
  start_At,
  end_At,
  data = [],
  label = "Select Date",
  selectedDate,
  handleDateChange = (date: any, validDate: boolean = true) => {},
  reservation,
  langValue,
  excludedDates,
  maxDays = 0   
}: any) => {
  const [error, setError] = React.useState<string>("");
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { alertMessageState } = bindActionCreators(
    actionCreators,
    dispatch
  );

  // Clear error when selectedDate changes externally and is valid
  

  let days = [
    { name: "Monday", id: 1 },
    { name: "Tuesday", id: 2 },
    { name: "Wednesday", id: 3 },
    { name: "Thursday", id: 4 },
    { name: "Friday", id: 5 },
    { name: "Saturday", id: 6 },
    { name: "Sunday", id: 0 },
  ];


  const isDateDisabled = (date: any) => {
    const day = dayjs(date);
    const dayOfMonth = day.date();
    const dayOfWeek = day.day(); // Sunday = 0, Monday = 1, ..., Saturday = 6

    const selectedDates =  dayjs(date); // Normalize to start of the day   
    const currentDate =  slug == 'primefood-catering-online' ? dayjs().add(1, 'day') : dayjs(); // Current date normalized
    const disabledBeforeDate = start_At ? dayjs(start_At) : null;
    const adjustMaxDays = maxDays > 0 ? maxDays - 1 : 0;
    const disabledAfterDate = maxDays > 0 ? dayjs().add(adjustMaxDays, 'day') : end_At ? dayjs(end_At) : null;
    let disabledDates: any = []; // Dates to disable
    let disabledWeekdays: any = []; // Weekdays to disable (Monday and Friday)
    let activeDays: any = [];


    
    if (type == 1) {
      disabledDates = [];
      disabledWeekdays = [];
    } else if (type == 2) {
      let dayId: any = [0, 1, 2, 3, 4, 5, 6];
      data.forEach((ele: any) => {
        if (ele?.active) {
          let findDay: any = days.find((item: any) => item.name === ele?.day);
          if(ele.slotsType == 1){
            let findMinMax = ele?.maxGuest >= reservation?.NoGuest;
            if (true) {
                activeDays.push(Number(findDay.id));
            }   
          }else{
            activeDays.push(Number(findDay.id))
          }
         
        }
      });

      dayId.forEach((ele: any) => {
        if (!activeDays?.includes(ele)) {
          disabledWeekdays.push(ele);
        }
      });
    } else if (type == 3) {
      let dayId: any = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ];
      data.forEach((ele: any) => {
        if (ele?.active) {
            if(ele?.slotsType == 1){
              let findMinMax = ele?.maxGuest >= reservation?.NoGuest;
            if(true){
                activeDays.push(Number(ele?.day));
            }
            }else{
              let findPkg = ele?.pkgId == reservation?.packageId
              activeDays.push(Number(ele?.day));
            }
        }
      });
      dayId.forEach((ele: any) => {
        if (!activeDays?.includes(ele)) {
          disabledDates.push(ele);
        }
      });
    }
    // i have to active maxdays from the current date to selected date
    let maxDaysCutoff = null;
    if (maxDays > 0) {
      const startDate = disabledBeforeDate || currentDate;
      maxDaysCutoff = startDate.add(maxDays - 1, 'day');
    }
    // Disable specific dates from the excludedDates array
    const isExcludedDate = excludedDates?.some((excludedDate: string) => {
      return selectedDates.isSame(dayjs(excludedDate, "DD-MM-YYYY"), "day");
    });

// Check if the day of the month or the day of the week is in the disabledDates or disabledWeekdays array
return (
  isExcludedDate || // Check if the date is in excludedDates
  disabledDates?.includes(dayOfMonth) ||
  disabledWeekdays?.includes(dayOfWeek) ||
  selectedDates?.isBefore(currentDate, "day") ||
  selectedDates?.isAfter(disabledAfterDate, "day") ||
  selectedDates?.isBefore(disabledBeforeDate, "day")
);
  };
  // Format function to change the date format
const handleChange = (date: any) => {
  if (date && isDateDisabled(date)) {
    setError(getLang({en: "Please select a valid date", ar: "يرجى تحديد تاريخ صالح."}, langValue));
    handleDateChange(date, false);
    return;
  }
  setError("");
  handleDateChange(date, true);
}
  return (
    <div id="DatePicker" className="mt-2">
      {label != "Duration" && (
        <p 
        className={`mb-0 label mb-2 familysora400 ${langValue === "ar" ? "text-right" : "text-left"}`}>{label}</p>
      )}
      <div style={langValue === "ar" ? { direction: "rtl" } : { direction: "ltr" }}>

      <LocalizationProvider dateAdapter={AdapterDayjs} >
        {/* <DatePicker
          value={selectedDate}
          onChange={handleDateChange}
          shouldDisableDate={isDateDisabled}
        /> */}
        <DatePicker
  value={selectedDate}
  onChange={handleChange}
  shouldDisableDate={isDateDisabled}
  slotProps={{
    day: (ownerState) => {
      const { day } = ownerState;

      const formatted = day.format("DD-MM-YYYY");
      
      const isExcluded = excludedDates.includes(formatted);

      if (!isExcluded) return {};
      return {
        sx: {
          position: "relative",
          color: "#d32f2f !important", // make number red
          pointerEvents: "none",
          cursor: "not-allowed",
          "&::after": {
            content: '"Sold"',   // ❌ on date
            position: "absolute",
            top: 0,
          left: 0,
            paddingTop: "6px",
            width: "100%",
            height: "100%",
            backgroundColor: "#A0A0A0",
            color: "#fff",
            fontSize: "12px",
            textAlign: "center",
            cursor: "not-allowed",  
            pointerEvents: "none",
            borderRadius: "50%",
            border: "1px solid #A0A0A0",
            borderWidth: "2px",
            borderStyle: "solid",
          },
        },
      };
    }
  }}
/>

      </LocalizationProvider>
      </div>
      {error && <p className="error" style={{color: "red"}}>{error}</p>}
    </div>
  );
};
export default BasicDatePicker;
